import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Button from "../../shared/components/Button/Button";

const StyledJobCard = styled.div`
  background-color: ${({ theme }) => `${theme.jobCardBackgroundColor}`}; ;
`;

const StyledLocation = styled.p`
  font-weight: 500;
`;

const StyledSalary = styled.div`
  border-top: #d0ccbe 1px solid;
  font-weight: 500;
`;

const StyledLeftButton = styled.button`
  background-color: ${({ theme }) => `${theme.jobCardBackgroundColor}`};
  min-height: 3.5rem;
  border: ${({ theme }) => `${theme.primaryColor}`} 1px solid;
  color: ${({ theme }) => `${theme.primaryColor}`};
`;

function JobCard(props) {
  const { vacancy, onDetailsClick, onApplyClick } = props;

  const handleDetailsClick = () => {
    if (typeof onDetailsClick === "function") {
      onDetailsClick(vacancy);
    }
  };

  if (isEmpty(vacancy)) {
    return null;
  }

  return (
    <StyledJobCard className="mb-3 mb-lg-4 p-3">
      <h2 className="text-truncate" title={vacancy.jobTitle}>
        {vacancy?.jobTitle}
      </h2>
      {vacancy?.location && (
        <StyledLocation className="mb-2 text-truncate">
          {vacancy.location?.city}
        </StyledLocation>
      )}
      {vacancy?.remuneration && (
        <StyledSalary className="pt-2 pb-4">
          {vacancy.remuneration?.description}
        </StyledSalary>
      )}
      <div className="d-flex">
        <StyledLeftButton
          className="flex-grow-1 text-uppercase fw-bold"
          onClick={handleDetailsClick}
          type="button"
        >
          Learn more
        </StyledLeftButton>
        <Button className="flex-grow-1" onClick={() => onApplyClick(vacancy)}>
          Apply now
        </Button>
      </div>
    </StyledJobCard>
  );
}

export default observer(JobCard);

JobCard.propTypes = {
  onApplyClick: PropTypes.func.isRequired,
  onDetailsClick: PropTypes.func.isRequired,
  vacancy: PropTypes.shape({
    jobTitle: PropTypes.string,
    location: PropTypes.objectOf(),
    remuneration: PropTypes.objectOf(),
  }),
};

JobCard.defaultProps = {
  vacancy: {},
};
